import { Type } from "class-transformer";
import AssetClass from "./assetClass";

export default class assetSubclass {
  /** Asset class to which this asset subclass belongs to. */
  @Type(() => AssetClass)
  assetClass: AssetClass
  /**
   * @param id GUID of this asset type.
   * @param name 
   * @param description 
   * @param fixProtocolId FIX Protocol ID of this asset type, as defined on fixtrading community dictionary for default values.
   * @param assetClass Asset class to which this asset subclass belongs to.
   */
  constructor(
    public id: string | undefined,
    public name: string,
    public description: string,
    public fixProtocolId: number,
    assetClass: AssetClass
  ) {
    this.assetClass = assetClass
  }
}